var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "header-menu-dashboard-container" }, [
      _c("div", { staticClass: "page-header-dashboard" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-sm-6 col-md-6" }, [
            _c("h1", [
              _vm.isSX
                ? _c("img", {
                    staticClass: "dashboard-icons",
                    attrs: {
                      src: "/static/images/icons/smartexchange_icon_blue.svg",
                      alt: "smartexchange-icon",
                    },
                  })
                : _c("img", {
                    staticClass: "dashboard-icons",
                    attrs: {
                      src: "/static/images/icons/submission_icon_blue.svg",
                      alt: "submission-icon",
                    },
                  }),
              _vm._v("Projects "),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-6 col-md-offset-2 col-md-4" },
            [
              _c(
                "div",
                {
                  staticClass: "input-group-btn select",
                  attrs: { id: "select1" },
                },
                [
                  _vm._m(0),
                  _c(
                    "ul",
                    {
                      staticClass: "dropdown-menu option",
                      attrs: { role: "menu" },
                    },
                    _vm._l(
                      Object.keys(_vm.dropdownItems),
                      function (key, index) {
                        return _c("li", { key: index }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                target: "_blank",
                                href: _vm.constructUrl(
                                  _vm.dropdownItems[key].manual
                                ),
                              },
                            },
                            [_vm._v(_vm._s(key))]
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "sb-project" },
        _vm._l(_vm.data, function ({ items, index }) {
          return _c("div", { key: index, staticClass: "col-md-12" }, [
            _c("div", { staticClass: "page-subheader-dashboard" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-12" }, [
                  _c("h2", [_vm._v(_vm._s(index))]),
                ]),
              ]),
              _c("table", { staticClass: "product-table" }, [
                _vm._m(1, true),
                _c(
                  "tbody",
                  _vm._l(items, function (item) {
                    return _c(
                      "tr",
                      {
                        key: item.id,
                        on: {
                          click: function ($event) {
                            return _vm.goToLink(item.nextUrl)
                          },
                        },
                      },
                      [
                        _c("td", { staticClass: "product-table-name" }, [
                          _vm._v(" " + _vm._s(item.name) + " "),
                        ]),
                        _c("td", { staticClass: "product-table-status" }, [
                          _vm._v(" " + _vm._s(item.status) + " "),
                        ]),
                        _c("td", { staticClass: "product-table-modified" }, [
                          _vm._v(" " + _vm._s(item.lastModified) + " "),
                        ]),
                        _vm._m(2, true),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c("hr", { staticClass: "product-divider" }),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-default dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-expanded": "false",
        },
      },
      [
        _c("span", { staticClass: "selected" }, [
          _vm._v("Quick Start Guide / User Manuals"),
        ]),
        _c("span", { staticClass: "caret" }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Project Name")]),
        _c("th", [_vm._v("Status")]),
        _c("th", [_vm._v("Last Modified")]),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { staticClass: "product-table-chevron" }, [
      _c("i", { staticClass: "fa fa-chevron-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }